<div class="incident-filter-container">
  <mat-form-field class="filter-item">
    <mat-label>Search by incident number</mat-label>
    <fa-icon matPrefix [icon]="['fas', 'magnifying-glass']"></fa-icon>
    <input
      data-test-id="SEARCH_FILTER_INPUT"
      matInput
      name="search"
    [(ngModel)]="search"
    (keyup.enter)="filters.search = search; filtersUpdated.emit(filters)" />
  </mat-form-field>

  <mat-form-field class="filter-item">
    <mat-label>Start Date</mat-label>
    <input
      placeholder="Start Date"
      matInput
      [matDatepicker]="startDatePicker"
      [(ngModel)]="startDate"
      name="startDate"
      (dateChange)="onDateUpdated('startDate', $event)" />
    <mat-datepicker-toggle
      matSuffix
      [for]="startDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #startDatePicker></mat-datepicker>
  </mat-form-field>

  <mat-form-field class="filter-item">
    <mat-label>End Date</mat-label>
    <input
      placeholder="End Date"
      matInput
      [matDatepicker]="endDatePicker"
      [(ngModel)]="endDate"
      name="endDate"
      (dateChange)="onDateUpdated('endDate', $event)" />
    <mat-datepicker-toggle
      matSuffix
      [for]="endDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #endDatePicker></mat-datepicker>
  </mat-form-field>

  <app-autocomplete
    label="User"
    [(value)]="reporter"
    placeholder="Reporter"
    [options]="userOptions"
    class="filter-item filter-dropdown"
    (selectionChange)="onFilterUpdated('reporterId', $event)"
  ></app-autocomplete>

  <app-autocomplete
    label="Type"
    placeholder="Type"
    [(value)]="incidentTypeId"
    [options]="incidentTypeOptions"
    class="filter-item filter-dropdown"
    (selectionChange)="onFilterUpdated('incidentTypeId', $event)"
  ></app-autocomplete>

  <app-autocomplete
    label="Status"
    [(value)]="status"
    placeholder="Status"
    [options]="incidentStatusOptions"
    class="filter-item filter-dropdown"
    (selectionChange)="onFilterUpdated('status', $event)"
  ></app-autocomplete>

  <button
    type="button"
    mat-raised-button
    (click)="onClearFilters()"
    class="secondary-button"
    [attr.data-test-id]="'clear-filters-incidents-btn'">
    Clear Filters
  </button>
</div>
